//========== Projects Section Component ==========

import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faProjectDiagram } from "@fortawesome/free-solid-svg-icons";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import projectsItems from "../../js/projectsItems";
import "./projects.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Single = ({
  item
}) => {
  const navigate = useNavigate(); // Initialize useNavigate
  const controlsImage = useAnimation();
  const controlsText = useAnimation();
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: false,
    threshold: 0.5
  });
  React.useEffect(() => {
    if (inView) {
      controlsImage.start("visible");
      controlsText.start("visible");
    } else {
      controlsImage.start("hidden");
      controlsText.start("hidden");
    }
  }, [controlsImage, controlsText, inView]);
  const imageVariants = {
    hidden: {
      opacity: 0,
      x: -50
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 50,
        duration: 0.8
      }
    }
  };
  const textVariants = {
    hidden: {
      opacity: 0,
      x: 50
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 50,
        duration: 0.8
      }
    }
  };

  // Function to navigate to the error page
  const handleComingSoonClick = () => {
    navigate('/error');
  };
  return /*#__PURE__*/_jsx("div", {
    className: "container",
    ref: ref,
    children: /*#__PURE__*/_jsxs("div", {
      className: "wrapper",
      children: [/*#__PURE__*/_jsx(motion.div, {
        className: "imageContainer",
        initial: "hidden",
        animate: controlsImage,
        variants: imageVariants,
        children: /*#__PURE__*/_jsx("img", {
          src: item.img,
          alt: item.title,
          style: {
            width: "100%",
            height: "auto",
            objectFit: "cover"
          }
        })
      }), /*#__PURE__*/_jsxs(motion.div, {
        className: "textContainer",
        initial: "hidden",
        animate: controlsText,
        variants: textVariants,
        children: [/*#__PURE__*/_jsx("h2", {
          children: item.title
        }), /*#__PURE__*/_jsx("p", {
          children: item.desc
        }), item.comingSoon ? /*#__PURE__*/_jsx("button", {
          className: "comingSoonButton",
          onClick: handleComingSoonClick,
          children: "Coming Soon"
        }) : /*#__PURE__*/_jsx("a", {
          href: item.url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "sourceCodeButton",
          children: "Show in GitHub"
        })]
      })]
    })
  });
};
const Projects = () => {
  return /*#__PURE__*/_jsxs("div", {
    className: "projects",
    id: "projects",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "projectsHeader",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: faProjectDiagram
      }), /*#__PURE__*/_jsxs("h2", {
        children: ["Previous ", /*#__PURE__*/_jsx("span", {
          className: "projectsSpan",
          children: " Projects "
        })]
      })]
    }), projectsItems.map((item, index) => /*#__PURE__*/_jsx(Single, {
      item: item
    }, index))]
  });
};
export default Projects;